import React from "react";
import { Form, Input, Button, DatePicker } from 'antd';
import { graphicPackingUseMutation } from '../../hooks';
import EntityRemoveButton from 'components/service/entity-remove-button';
import { Localize } from "components/service";
import moment from 'moment';

const GraphicPackingEditForm = ({ graphicPacking }) => {
    const [ form ] = Form.useForm();

    const {
        _setGraphicPackingCreateUpdate,
        loadingGraphicPackingCreateUpdate: loading,
    } = graphicPackingUseMutation.createUpdate(graphicPacking?.id);

    const {
        _setMutationGraphicPackingDelete,
        loadingMutationGraphicPackingDelete,
    } = graphicPackingUseMutation.Delete(graphicPacking?.id);

    const fieldValueStartBuildAt = Form.useWatch('start_build_at', form);
    const fieldValueStartEventAt = Form.useWatch('start_event_at', form);

    const disabledDate = (current, name) => {
        const fieldValue = name === 'start_build_at' ? fieldValueStartBuildAt : fieldValueStartEventAt;
        return current && current < (moment(fieldValue))
    };

    return (
        <Form
            key="edit-graphic-packing-form"
            layout="vertical"
            form={ form }
            className="model-form edit-graphic-packing-form"
            onFinish={ (values) => {
                _setGraphicPackingCreateUpdate({
                    variables: {
                        input: {
                            id: graphicPacking?.id ? +graphicPacking.id : undefined,
                            ...values,
                            start_build_at: values.start_build_at ? values.start_build_at.format('YYYY-MM-DD HH:mm:ss') : null,
                            start_event_at: values.start_event_at ? values.start_event_at.format('YYYY-MM-DD HH:mm:ss') : null,
                        }
                    }
                })
            } }>

            <Form.Item
                name="title"
                label={ <Localize>FORMS.Input_Label_ExhibitionName</Localize> }
                initialValue={ graphicPacking?.title }
                rules={ [
                    { required: true, message: <Localize>FORMS.Input_Placeholder_ExhibitionName</Localize> }
                ] }
            >
                <Input name="title" />
            </Form.Item>

            {/* <Form.Item
                name="status"
                label={ <Localize>FORMS.Input_Label_ElfeOnline</Localize> }
                initialValue={ graphicPacking?.status }
                valuePropName="checked"
                className='form-item-switch'
            >
                <Switch />
            </Form.Item> */}

            <div className="row-grid grid-gap-10 row-gap-0 col-md-2">
                <Form.Item
                    name="start_build_at"
                    label={ <Localize>FORMS.Input_Label_ConstructionStarts</Localize> }
                    initialValue={ graphicPacking?.start_build_at && moment(graphicPacking?.start_build_at) }
                >
                    <DatePicker
                        onChange={ value => {
                            form.setFieldsValue({ start_event_at: moment(value).add(1, 'days') });
                        } }
                        minuteStep={ 15 }
                        placeholder={ Localize({ children: "FORMS.Input_Placeholder_SelectDate" }).props.children }
                        showTime format="DD.MM.YYYY HH:mm"
                    />
                </Form.Item>

                <Form.Item
                    name="start_event_at"
                    label={ <Localize>FORMS.Input_Label_ExhibitionStarts</Localize> }
                    initialValue={ graphicPacking?.start_event_at && moment(graphicPacking?.start_event_at) }
                >
                    <DatePicker
                        minuteStep={ 15 }
                        disabledDate={ (current) => disabledDate(current, 'start_build_at') }
                        placeholder={ Localize({ children: "FORMS.Input_Placeholder_SelectDate" }).props.children }
                        showTime format="DD.MM.YYYY HH:mm"
                    />
                </Form.Item>
            </div>

            <div className="form-btn-holder">
                { graphicPacking?.id &&
                    <EntityRemoveButton
                        modalButton={
                            <Button className="ant-btn-secondary">
                                <Localize>EXHIBITION.Button_Text_Delete</Localize>
                            </Button>
                        }
                        nameEntity={ Localize({ children: "ENTITY.Modal_Title_ExhibitionEvent" }).props.children }
                        dataNameEntity={ `${ graphicPacking?.title }` }
                        loading={ loadingMutationGraphicPackingDelete }
                        deleteMutation={ _setMutationGraphicPackingDelete }
                        variables={ {
                            id: +graphicPacking?.id,
                        } }
                    /> }

                <Button
                    className="btn-right"
                    type="primary"
                    htmlType="submit"
                    loading={ loading }
                >
                    { graphicPacking?.id ? <Localize>GLOBAL.Button_Text_SaveChanges</Localize> : <Localize>GLOBAL.Button_Text_CreatePacking</Localize> }
                </Button>
            </div>
        </Form>
    );
};

export default GraphicPackingEditForm;